import { generateTestId } from "@client-shared";

const base = "TextLoader";

export const setTextLoaderTestId = (identifier: string): string => generateTestId(base, identifier);
